export default "__VITE_ASSET__Bk4B3e4Z__"